import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, LogOut, Trophy } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const UserProfile = () => {
  const { user, isAuthenticated, userDisplayName, userPhoto, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();

  if (!isAuthenticated) return null;

  const handleSignOut = async () => {
    try {
      setShowDropdown(false);
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowDropdown(!showDropdown)}
        className="flex items-center gap-2 bg-blue-600 text-white px-3 py-2 rounded-lg hover:bg-blue-700"
      >
        {userPhoto ? (
          <img
            src={userPhoto}
            alt={userDisplayName}
            className="w-6 h-6 rounded-full"
          />
        ) : (
          <User size={18} />
        )}
        <span className="hidden sm:inline">{userDisplayName}</span>
      </button>

      {showDropdown && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border z-50">
          <div className="py-2">
            <div className="px-4 py-2 border-b">
              <p className="text-sm font-medium text-gray-900">{userDisplayName}</p>
              <p className="text-xs text-gray-500">{user?.email}</p>
            </div>
            <button
              onClick={() => { navigate('/leaderboard'); setShowDropdown(false); }}
              className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
            >
              <Trophy size={16} />
              View Leaderboard
            </button>
            <button
              onClick={handleSignOut}
              className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
            >
              <LogOut size={16} />
              Sign Out
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
